import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Emotions",
  "description": "",
  "published": "2008-03-10T00:00:00.000Z",
  "redirect_from": ["/blog/emotions/swizec/123"],
  "categories": "food for thought",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You're a rock, a robot some people say, anything but normal, barely human. But then that special someone comes along and arouses emotions inside you. At first it takes the edge off, then the cynicism vanishes, the urge to hurt and flame people disappears and you become almost ... nice, a human being, a good person even. You're happy and everyone you touch aknowledges you've changed for the better.`}</p>
    <p>{`But then along with everything else the old friend comes. You know the one, the one that keeps you joyless, void, unfulfilled. The one that keeps you awake at night and unable to grab onto any work, unable to derive pleasure from just about anything. Before you hated yourself, but didn't care, mind or notice, now nothing you touch works, everything goes awry.`}</p>
    <p>{`You know it's destroying you, that it will slowly be your death, or at least the death of everything that makes you you, everything that makes you creative, everything that makes you special. But still, you do not want to remove the one thing you know is the root of the problem because when that special someone is around all the bad goes away, it's not there, why it's almost like before when the bad was burried deep inside. Almost, but not quite.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      